<script setup lang="ts">
import { usePdpPaneOwnScroll } from '@design-system/composables/usePdpPaneOwnScroll'

const infoScrollRef = ref<HTMLElement | null>(null)
const { paneScrollStyle: infoScrollStyle } = usePdpPaneOwnScroll(infoScrollRef)
</script>
<template>
  <div class="ecomm-container relative">
    <!-- Top bar with back breadcrumb for mobile -->
    <div
      class="giorgioArmaniHeaderPaddingTop positive-padding absolute top-4 z-10 flex w-full items-center justify-between md:top-6 lg:hidden"
    >
      <slot name="top-bar" />
    </div>
    <div
      class="grid-standard bg-primitives-off-white giorgioArmaniHeaderPaddingTop relative lg:items-start lg:px-16"
    >
      <!-- right infos: pinned next to the gallery and scrollable on its own -->
      <div
        ref="infoScrollRef"
        data-pdp-info-scroll
        class="lg:scrollbar-hide order-2 col-span-12 h-full lg:sticky lg:top-[var(--header-default-height)] lg:order-2 lg:col-span-4 lg:h-[calc(100dvh-var(--header-default-height))] lg:overflow-y-auto"
        :style="infoScrollStyle"
      >
        <slot name="right-side-pdp" />
      </div>
      <!-- Swiper container, needed for complete the look placement -->
      <slot name="left-side-pdp" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.ecomm-container {
  /* Clips mobile gallery slides (w-screen) without affecting desktop fixed thumbnails */
  contain: paint;

  @screen lg {
    contain: none;
  }
}
</style>
